import { create } from "apisauce";
import store from '../store'

const ipRegistry = create({
	baseURL: "https://api.ipstack.com",
});
const ipStackClient = create({
    baseURL: process.env.REACT_APP_IPSTACK_API
})
const adminApi = create({
	baseURL: process.env.REACT_APP_API_END_POINT + "/api/v1/",
});
const adminCardApi = create({
	baseURL: process.env.REACT_APP_API_END_POINT_CARD + "/api/v1/",
});
adminApi.axiosInstance.interceptors.request.use((config) => {
	const access_token = store.getState().oidc?.deviceToken;
	config.headers.Authorization = `Bearer ${access_token}`;
   return config;
});
adminCardApi.axiosInstance.interceptors.request.use((config) => {
	const access_token = store.getState().oidc?.deviceToken;
	config.headers.Authorization = `Bearer ${access_token}`;
   return config;
})
export {
	ipRegistry,
	adminApi,
	adminCardApi,
	ipStackClient,

};

